module.exports = __webpack_public_path__ + "img/胡萝卜.8356ccb6.png";